import { useState, useEffect } from 'react';
import { TaskStatus } from '../../services/TaskStatus';

export const useTaskStatus = (ticket, taskIds, baseStatus = TaskStatus.NOT_STARTED) => {
    const [status, setStatus] = useState("NotStarted");

    const getTaskCompletions = (ticket, taskIds) => {
        let taskCompletions = (ticket ? ticket.taskCompletionStates : []) || []
        return taskCompletions.filter(x => taskIds.includes(x.workflowTaskId) && x.status !== TaskStatus.INVALID);
    }
    
    useEffect(() => {
        let allComplete = (taskIds || []).length > 0;  // if there are no tasks, let's call it not started
        let anyComplete = false;
        let anyNotStarted = false;
        let anyFailed = false;
        let anyInProgress = false;

        if ((taskIds || []).length === 0) {
            // if no tasks are specified, fall back to base status
            setStatus(baseStatus)
            return
        } else {

            taskIds.forEach((taskId, i) => {
                let tc = getTaskCompletions(ticket, [taskId]);
                if (tc.length === 0) {
                    allComplete = false;
                    anyNotStarted = true;
                } else if (tc.some(x => x.status === TaskStatus.FAILED)) {
                    allComplete = false;
                    anyFailed = true;
                } else if (tc.some(x => x.status === TaskStatus.IN_PROGRESS)) {
                    allComplete = false;
                    anyInProgress = true;
                } else if (!tc.some(x => x.status === TaskStatus.COMPLETE)) {
                    allComplete = false;
                } else if (tc.some(x => x.status === TaskStatus.COMPLETE)) {
                    anyComplete = true
                }
            })

            // look for partial completion
            if (anyNotStarted && (anyInProgress || anyComplete)) {
                anyInProgress = true
            }

            // look for a completed status
            if (allComplete) {
                setStatus(TaskStatus.COMPLETE)
            } else if (anyFailed) {
                setStatus(TaskStatus.FAILED)
            } else if (anyInProgress) {
                setStatus(TaskStatus.IN_PROGRESS)
            } else {
                setStatus(TaskStatus.NOT_STARTED)
            }
        }
    }, [ticket, taskIds])

    return [status, getTaskCompletions(ticket, taskIds)];
}
